// frontend/src/farm/animalMenu.mjs — what a tap on a farm animal offers (spec 4c §2), pure.
import { isHungry } from './farmAnimals.mjs';
import { serverNow } from '../state/serverClock.mjs';
const PRODUCT = { jajko: '{egg}', mleko: '{milk}' };
export function animalMenuItems(a, state, nowMs = serverNow()) {
  const spec = state.catalog.farm.animals[a.type];
  const out = [];
  if ((a.pending_count ?? 0) > 0) out.push({ op: 'collect_animal', label: `Zbierz ${a.pending_count} ${PRODUCT[spec.produces] ?? ''}`.trim() });
  if (!isHungry(a, nowMs, state.catalog.farm.animal_rules?.feed_hours)) {
    out.push({ op: 'feed_animal', label: 'Najedzona {check}', enabled: false, reason: 'ANIMAL_NOT_HUNGRY' });
  } else if ((state.inventory?.foods?.[spec.food_id] ?? 0) > 0) out.push({ op: 'feed_animal', label: 'Nakarm' });
  else {
    // Hungry and no food: say so and lead to the Rynek's Zwierzęta tab (owner 2026-10-01: the
    // button just vanished and food was sold only in the town's pet shop).
    const name = state.catalog?.foods?.[spec.food_id]?.name_pl?.toLowerCase();
    const missing = name ? name.replace(/o$/, 'a') : 'jedzenia';      // ziarno → ziarna, siano → siana
    out.push({ op: 'buy_food', food: spec.food_id, label: `Nie masz ${missing} — kup w Rynku {cart}` });
  }
  // Petting fills happiness to 100, only below 80 (owner 2026-09-30): at 80+ the item says so instead.
  const happy = (a.happiness ?? 0) >= (state.catalog.farm.animal_rules?.pet_below ?? 80);
  out.push(happy ? { op: 'pet_animal', label: 'Jest szczęśliwa {heart}', enabled: false, reason: 'ANIMAL_HAPPY' } : { op: 'pet_animal', label: 'Pogłaskaj', enabled: true });
  return out;
}
export const animalCursor = () => 'object';                          // the open hand over every animal (owner)
// A tap: eggs / milk waiting → collect (owner 2026-09-30); hungry → fed if there is food, else the menu; otherwise
// it is petted straight away with hearts (owner 2026-10-01), or — already happy, petting only works
// below pet_below — just the hearts. No state → the old rule (menu).
export function animalTapAction(a, state = null, nowMs = serverNow()) {
  if ((a.pending_count ?? 0) > 0) return 'collect';
  const rules = state?.catalog?.farm?.animal_rules;
  if (!state) return 'menu';
  if (isHungry(a, nowMs, rules?.feed_hours)) {
    // fed on the spot when there is food (owner 2026-10-01); no food → the menu says so, with a way to the Rynek
    const food = state.catalog?.farm?.animals?.[a.type]?.food_id;
    return (state.inventory?.foods?.[food] ?? 0) > 0 ? 'feed' : 'menu';
  }
  return (a.happiness ?? 0) >= (rules?.pet_below ?? 80) ? 'happy' : 'pet';
}
